import { render, staticRenderFns } from "./AdminSuperChallengeCenter.vue?vue&type=template&id=27580164&scoped=true&lang=pug&"
import script from "./AdminSuperChallengeCenter.vue?vue&type=script&lang=js&"
export * from "./AdminSuperChallengeCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27580164",
  null
  
)

export default component.exports